import apiClient from './apiClient';

const API_URL = '/tramites/ganancias';

// Listar / filtrar trámites de Ganancias
export const getTramitesGanancias = async (idCliente = null, idEstadoActual = null) => {
    const params = {};
    if (idCliente && idCliente.trim() !== '') params.idCliente = idCliente;
    if (idEstadoActual) params.idEstadoActual = idEstadoActual;

    const response = await apiClient.get(API_URL, { params });
    return response.data;
};

// Detalle de un trámite (incluye checklist)
export const getTramiteGananciasById = async (id) => {
    const response = await apiClient.get(`${API_URL}/${id}`);
    return response.data;
};

// Crear un nuevo trámite de Ganancias
export const crearTramiteGanancias = async (tramiteData) => {
    try {
        const response = await apiClient.post(API_URL, tramiteData);
        return response.data;
    } catch (error) {
        console.error('Error al crear trámite de Ganancias:', error.response?.data || error.message);
        throw error;
    }
};

// Preview en vivo del checklist de documentación (siempre los mismos 6 formularios)
export const getChecklistFormularios = async () => {
    const response = await apiClient.get(`${API_URL}/formularios`);
    return response.data;
};

// Editar datos del trámite (no el cliente)
export const actualizarTramiteGanancias = async (id, dto) => {
    const response = await apiClient.put(`${API_URL}/${id}`, dto);
    return response.data;
};

// Editar solo el análisis inicial (período reclamado, montos), independiente del cambio de estado
export const actualizarAnalisisGanancias = async (id, dto) => {
    const response = await apiClient.put(`${API_URL}/${id}/analisis`, dto);
    return response.data;
};

// Actualizar observaciones/comentarios (nota editable con firma)
export const actualizarComentariosGanancias = async (id, comentarios) => {
    const response = await apiClient.patch(`${API_URL}/${id}/comentarios`, { comentarios });
    return response.data;
};

// Avanzar de estado: cada transición manda su propio mini-formulario (destino + dato de la etapa)
export const avanzarEstadoGanancias = async (id, dto) => {
    const response = await apiClient.patch(`${API_URL}/${id}/estado`, dto);
    return response.data;
};

// Actualizar un ítem del checklist (marcar presentado / adjuntar archivo)
export const actualizarChecklistItem = async (idItem, { presentado, idArchivo }) => {
    const response = await apiClient.patch(`${API_URL}/formularios/${idItem}`, { presentado, idArchivo });
    return response.data;
};

const gananciasService = {
    getTramitesGanancias,
    getTramiteGananciasById,
    crearTramiteGanancias,
    getChecklistFormularios,
    actualizarChecklistItem,
    actualizarTramiteGanancias,
    actualizarAnalisisGanancias,
    actualizarComentariosGanancias,
    avanzarEstadoGanancias,
};

export default gananciasService;
